import { useState, createRef } from 'react';
import Modal from '../../../components/Modal';
import { useDropzone } from 'react-dropzone';
import Button from '../../../components/Button';
import styled, { useTheme } from 'styled-components';
import { useDispatch } from 'react-redux';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

const DropzoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  border: 1px dashed ${({ theme }) => theme.text.secondary};
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  margin-bottom: 10px;
  height: 200px;
  text-align: center;
`;

const Label = styled.p`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 12px;
`;

const CropperContainer = styled.div`
  width: 100%;
  max-width: 900px;
  max-height: 70vh;
  margin: 0 auto;

  .cropper-container {
    max-width: 900px;
    max-height: 70vh;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
`;

const UploadImage = styled.img`
  width: 53px;
  padding-bottom: 10px;
`;

const CustomizeCardModal = ({ onClose, onSelectCard }) => {
  const [loading, setLoading] = useState(false);
  const [image, setImageState] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const cropperRef = createRef();
  const theme = useTheme();

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        setImageState(imageData);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop,
  });

  const getCropData = async () => {
    setLoading(true);
    if (cropperRef.current?.cropper) {
      const croppedDataUrl = cropperRef.current.cropper
        .getCroppedCanvas()
        .toDataURL();
      await onSelectCard(croppedDataUrl);
    }
    setLoading(false);
  };

  return (
    <Modal onClose={onClose}>
      <div>
        <h3
          style={{
            textAlign: 'center',
            paddingBottom: 24,
          }}
        >
          Customize Card
        </h3>
        {!showCropper ? (
          <>
            <DropzoneContainer {...getRootProps()}>
              <UploadImage src='/upload.webp' />
              <input {...getInputProps()} />
              <p
                style={{
                  fontSize: 14,
                }}
              >
                Drag image here or{' '}
                <span
                  style={{
                    color: `${theme.primary.primary}`,
                    fontWeight: 600,
                  }}
                >
                  click to upload
                </span>
              </p>
            </DropzoneContainer>
            <Label>jpg/png files with a size less than 1MB.</Label>
          </>
        ) : (
          <>
            <CropperContainer>
              <Cropper
                ref={cropperRef}
                zoomTo={0}
                initialAspectRatio={407 / 226}
                src={image}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                guides={true}
                aspectRatio={407 / 226}
              />
            </CropperContainer>
            <ButtonContainer>
              <Button variant='secondary' onClick={() => setShowCropper(false)}>
                Cancel
              </Button>
              <Button variant='primary' onClick={getCropData} loading={loading}>
                Crop & Save
              </Button>
            </ButtonContainer>
          </>
        )}
      </div>
    </Modal>
  );
};

export default CustomizeCardModal;
